import React from "react";
import { Plus, Minus, Phone } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Do you handle insurance claims directly with providers?",
  answer: "Yes, we specialize in insurance repairs. We work closely with all major insurance companies to streamline the assessment and repair process, ensuring your caravan is restored to factory standards with minimal hassle for you."
}, {
  question: "How long does a typical hail damage repair take?",
  answer: "The timeline for hail damage depends on the extent of the impact and parts availability. Generally, most repairs are completed within 2 to 4 weeks. We provide a detailed schedule once the initial assessment and parts ordering are finalized."
}, {
  question: "Are your technicians qualified for electrical and plumbing work?",
  answer: "Absolutely. Our team includes specialists qualified to handle complex caravan electrical systems, solar installations, and plumbing repairs. All work is performed with industrial precision to ensure safety and long-term reliability on the road."
}, {
  question: "Do you offer warranties on structural repairs?",
  answer: "We stand behind our craftsmanship. All structural repairs and new installations come with a comprehensive warranty. We use high-grade materials and engineering-focused techniques to ensure your caravan remains in optimal condition."
}, {
  question: "Can you install modern solar and lithium battery systems?",
  answer: "Yes, we specialize in off-grid power upgrades. From solar panel mounting to advanced lithium battery management systems, we provide professional installations that enhance your caravan's independence and efficiency."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="29082" id="repair-faq" ref={ref} className={`py-20 lg:py-28 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4 tracking-tighter uppercase font-sans">
            Repair FAQ
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-medium leading-relaxed">
            Expert answers regarding caravan maintenance, insurance claims, and structural repairs in South Windsor.
          </p>
        </div>

        <div className="bg-card rounded-xl shadow-xl border border-border p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full space-y-2">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border last:border-0 px-2" data-index={i}>
                <AccordionTrigger className="group hover:no-underline py-5 text-left text-base md:text-xl font-bold text-foreground tracking-tight [&>svg:last-child]:hidden">
                  <span className="flex-1 pr-4">{faq.question}</span>
                  <span className="relative flex size-5 shrink-0 items-center justify-center text-secondary transition-colors group-hover:text-secondary/80">
                    <Plus className="absolute size-5 transition-transform duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                    <Minus className="absolute size-5 transition-transform duration-300 rotate-90 opacity-0 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" />
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-6 pr-8 font-medium">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex flex-col items-center gap-4 p-8 rounded-xl bg-muted/30 border border-border">
            <p className="text-foreground font-bold text-xl tracking-tight uppercase font-sans">
              Need a specific repair quote?
            </p>
            <Button asChild size="lg" className="rounded-sm px-10 font-bold bg-accent text-accent-foreground hover:bg-accent/90 transition-all shadow-md">
              <Link to="tel:0245771234">
                <Phone className="mr-2 size-5" />
                Call (02) 4577 1234
              </Link>
            </Button>
            <p className="text-xs font-mono text-muted-foreground uppercase tracking-widest">
              Available Mon-Fri 8am - 5pm
            </p>
          </div>
        </div>
      </div>
    </section>;
}